import './Nav.scss';

import React from 'react';
import {NavLink as Link} from 'react-router-dom';

class NavComponent extends React.Component {
  render() {
    const authService = this.props.authService;
    const menuItems = [
      {
        slug: 'Forhandlere',
        route: '',
        icon: 'search',
        children: [
          {
            slug: 'Merker',
            route: 'merker',
            icon: 'search'
          },
          {
            slug: 'Forhandlerregister',
            route: 'forhandlere',
            icon: 'search'
          },
          {
            slug: 'Kampanjer',
            route: 'campaigns',
            icon: 'search'
          },
          {
            slug: 'Nybilinformasjon',
            route: 'nybilinformasjon',
            icon: 'search'
          },
          {
            slug: 'Lease',
            route: 'leases',
            icon: 'search'
          },
          {
            slug: 'Artikler',
            route: 'articles',
            icon: 'search'
          }
        ]
      },
      {
        slug: 'Motorforum',
        route: '',
        icon: 'mf',
        children: [
          {
            slug: 'Artikler',
            route: 'motorforum/articles',
            icon: 'search'
          },
          {
            slug: 'Kampanjer',
            route: 'motorforum/campaigns',
            icon: 'search'
          }
        ]
      },
      {
        slug: 'Biler på lager',
        route: '',
        icon: 'car',
        children: [
          {
            slug: 'Mitsubishi',
            route: 'cars-in-stock/mitsubishi',
            icon: 'search'
          },
          {
            slug: 'Hongqi',
            route: 'cars-in-stock/hongqi',
            icon: 'search'
          }
        ]
      },
      /* {
        slug: 'Bilkonfigurator',
        route: 'bilkonfigurator',
        icon: 'search'
      },*/
      /*
      {
        slug: 'Mediebank',
        route: 'mediebank',
        icon: 'search',

        children: [
          {
            slug: 'Bilder',
            route: 'mediebank/bilder',
            icon: 'search'
          },
          {
            slug: 'Video',
            route: 'mediebank/video',
            icon: 'search'
          }
        ]
      },
      */
      {
        slug: 'Min side',
        route: '',
        icon: 'search',
        children: [
          {
            slug: 'Generasjoner',
            route: 'mypage',
            icon: 'search'
          },
          {
            slug: 'Gavekort',
            route: 'giftcards',
            icon: 'search'
          },
          {
            slug: 'Tilgang (Mitsubishi)',
            route: 'mypage/access/mitsubishi',
            icon: 'search'
          }
        ]
      },
      {
        slug: 'Garantivilkår',
        route: '',
        icon: 'search',
        children: [
          {
            slug: 'Mitsubishi',
            route: 'warranties/mitsubishi',
            icon: 'search'
          },
          {
            slug: 'Mitsubishi - garantiperioder',
            route: 'warrantyperiods/mitsubishi',
            icon: 'search'
          },
          {
            slug: 'Hongqi',
            route: 'warranties/hongqi',
            icon: 'search'
          },
          {
            slug: 'Hongqi - garantiperioder',
            route: 'warrantyperiods/hongqi',
            icon: 'search'
          },
          {
            slug: 'Garantitester',
            route: 'warrantytest',
            icon: 'search'
          }
        ]
      },
      {
        slug: 'Reservasjoner',
        route: '',
        icon: '',
        children: [
          {
            slug: 'MMC Norge AS',
            route: 'reservations/mmc',
            icon: ''
          },
          {
            slug: 'HBI Norge AS',
            route: 'reservations/hbi',
            icon: ''
          }
        ]
      },
      {
        slug: 'Admin',
        route: '',
        icon: 'search',
        children: [
          {
            slug: 'Leads',
            route: 'leads',
            icon: 'search'
          },
          {
            slug: 'Skjemaer',
            route: 'leadSchemas',
            icon: 'search'
          },
          {
            slug: 'Media',
            route: 'media',
            icon: 'search'
          },
          {
            slug: 'System',
            route: 'system',
            icon: 'search'
          }
        ]
      }
    ];

    const menuItemsAuthorized = menuItems.filter((item) => {
      return authService.isAuthorized(item.route);
    });

    return (
      <div className="navbar-default sidebar" role="navigation">
        <div className="sidebar-nav navbar-collapse collapse">
          <ul className="nav in" id="side-menu">
            {menuItemsAuthorized.map((route) => (
              <li key={route.slug}>
                {route.route &&
                  <Link to={`/${route.route}`}>{route.slug}</Link>
                }
                {route.route === '' &&
                  <span><strong>{route.slug} <i className="fa fa-angle-down"></i></strong></span>
                }
                {route.children &&
                  <ul className="nav sub-nav">
                    {route.children.map((child) => (
                      <li key={child.route}>
                        <Link to={`/${child.route}`}>{child.slug}</Link>
                      </li>
                    ))}
                  </ul>
                }
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

export default NavComponent;
